export default __webpack_public_path__ + "static/media/bgm.477f39d4.mp3";